/* Action Types */
export const SEARCH_SUGGESTIONS_FAIL = 'la/ui/searchSuggestions/FAIL';
export const SEARCH_SUGGESTIONS_REQUEST = 'la/ui/searchSuggestions/REQUEST';
export const SEARCH_SUGGESTIONS_SUCCESS = 'la/ui/searchSuggestions/SUCCESS';
